import { render, staticRenderFns } from "./LuckLogisticDetail.vue?vue&type=template&id=159dafd2&scoped=true"
import script from "./LuckLogisticDetail.vue?vue&type=script&lang=js"
export * from "./LuckLogisticDetail.vue?vue&type=script&lang=js"
import style0 from "./LuckLogisticDetail.vue?vue&type=style&index=0&id=159dafd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159dafd2",
  null
  
)

export default component.exports